'use client'

import { PropsWithChildren } from 'react'

import { Listing } from '@/data/getListing'
import { ModalGalleryProvider } from '../ModalGallery/GalleryContext'
import { remapListingAssetsToGallery } from './listingImages'

type ListingGalleryContextProps = PropsWithChildren<{
  listing: Listing
}>

export const ListingGalleryContext = ({ listing, children }: ListingGalleryContextProps) => {
  const { images } = remapListingAssetsToGallery(listing)
  return (
    <ModalGalleryProvider options={{ input: { caption: null, items: images, limit: 3 } }}>
      {children}
    </ModalGalleryProvider>
  )
}
